import { render, staticRenderFns } from "./CMRList.vue?vue&type=template&id=453401ac&"
import script from "./CMRList.vue?vue&type=script&lang=ts&"
export * from "./CMRList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports